require('./partials/_cursor')
require('./partials/_magnets')
require('./partials/_svg-anim')
require('./partials/_reveal')

console.log("%c There's nothing to see here!", "background: #282828; color: #bada55; margin: 20px 0; padding: 15px; border-radius: 4px")

// import { debugCSS } from 'debug-css';

// debugCSS({})